import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const BATCH_SIZE = 20;
const FLUSH_INTERVAL = 5000;
const ENDPOINT = '/tracking/clicks';

export default function ClickTracker() {
  const location = useLocation();
  const batch = useRef([]);
  const pathRef = useRef(location.pathname);

  useEffect(() => { pathRef.current = location.pathname; }, [location.pathname]);

  useEffect(() => {
    const flush = () => {
      if (!batch.current.length) return;
      const payload = JSON.stringify({ clicks: batch.current });
      batch.current = [];
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'application/json' }));
      } else {
        fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true }).catch(() => {});
      }
    };

    const onClick = (e) => {
      batch.current.push({
        path: pathRef.current,
        x_pct: parseFloat((e.clientX / window.innerWidth).toFixed(4)),
        y_pct: parseFloat((e.clientY / window.innerHeight).toFixed(4)),
      });
      if (batch.current.length >= BATCH_SIZE) flush();
    };

    document.addEventListener('click', onClick, { passive: true });
    const timer = setInterval(flush, FLUSH_INTERVAL);
    window.addEventListener('beforeunload', flush);

    return () => {
      document.removeEventListener('click', onClick);
      clearInterval(timer);
      window.removeEventListener('beforeunload', flush);
      flush();
    };
  }, []);

  return null;
}
